/*
 * crisp-triggers.js
 * Consolidated Crisp chat triggers — loaded via defer from theme.liquid.
 * Replaces: crisp-cart-idle.liquid, crisp-welcome-back.liquid, crisp-exit-intent.liquid
 *
 * Page detection uses body class "template-{name}" set by theme.liquid.
 * Product data comes from window._toptureProduct (hydrated by crisp-shared-utils.liquid).
 */
(function(){
  if (typeof ToptureCrisp === 'undefined') return;

  var body = document.body;
  var isCart       = body.classList.contains('template-cart');
  var isProduct    = body.classList.contains('template-product');
  var isCollection = body.classList.contains('template-collection');

  /* ═══════════════════════════════════════════
   * Cart-idle trigger (cart page only)
   * Fires after 60s if cart has items.
   * Uses isCartTrigger option to bypass session/cooldown.
   * ═══════════════════════════════════════════ */
  if (isCart) {
    (function(){
      if (sessionStorage.getItem('topture_cart_msg')) return;

      var DELAY = 60 * 1000;
      var CART_OPTS = { isCartTrigger: true };

      setTimeout(function(){
        ToptureCrisp.fetchCart()
          .then(function(cart){
            if (!cart.items || cart.items.length === 0) return;

            var item  = cart.items[0];
            var title = item.product_title.split('|')[0].trim();

            var ctx = {
              product:   title,
              url:       item.url,
              price:     (item.line_price / 100).toFixed(2),
              variant:   item.variant_title || '',
              cartTotal: (cart.total_price / 100).toFixed(2),
              trigger:   'cart-idle'
            };

            var shown = ToptureCrisp.showPicker(
              "cart-idle",
              "You're close! Anything holding you back on the **" + title + "**?",
              [
                { value: "shipping",  icon: "🚚", label: "Shipping questions",           selected: false },
                { value: "financing", icon: "💰", label: "Financing / monthly payments",  selected: false },
                { value: "install",   icon: "🔧", label: "Installation help",             selected: false },
                { value: "other",     icon: "💬", label: "Something else",                selected: false }
              ],
              ctx,
              CART_OPTS
            );

            if (shown) sessionStorage.setItem('topture_cart_msg', '1');
          })
          .catch(function(){
            var shown = ToptureCrisp.showText(
              "Almost there! If you have any questions about shipping, financing, "
              + "or installation, we're here to help.",
              { trigger: 'cart-idle-fallback' },
              CART_OPTS
            );

            if (shown) sessionStorage.setItem('topture_cart_msg', '1');
          });

      }, DELAY);
    })();
  }

  /* ═══════════════════════════════════════════
   * Welcome-back trigger (all pages except cart/checkout)
   * Fires after 2h absence for returning visitors.
   * ═══════════════════════════════════════════ */
  if (!isCart && !/\/checkouts/.test(window.location.pathname)) {
    (function(){
      if (ToptureCrisp.hasTriggered()) return;

      var AWAY_TIME = 2 * 60 * 60 * 1000;
      var now  = Date.now();
      var prev = null;

      try { prev = JSON.parse(localStorage.getItem('topture_visitor')); } catch(e){}

      // Corrupt/non-numeric stored state skips both early-returns below (NaN
      // comparisons are false) and lands fresh visitors in the deep-visitor
      // branch with 'welcome-back-visit-NaN' polluting analytics — reset it.
      if (prev && (typeof prev.count !== 'number' || typeof prev.t !== 'number'
          || isNaN(prev.count) || isNaN(prev.t))) {
        prev = null;
      }

      if (!prev) {
        localStorage.setItem('topture_visitor', JSON.stringify({ count: 1, t: now }));
        return;
      }

      var gap = now - prev.t;

      if (gap < AWAY_TIME) {
        prev.t = now;
        localStorage.setItem('topture_visitor', JSON.stringify(prev));
        return;
      }

      prev.count++;
      prev.t = now;
      localStorage.setItem('topture_visitor', JSON.stringify(prev));

      if (!ToptureCrisp.canShowWelcomeBack()) return;

      setTimeout(function(){
        if (ToptureCrisp.hasTriggered()) return;

        ToptureCrisp.fetchCart()
          .then(function(cart){
            if (ToptureCrisp.hasTriggered()) return;

            var shown = false;

            if (cart.items && cart.items.length > 0) {
              var item  = cart.items[0];
              var title = item.product_title.split('|')[0].trim();

              var cartCtx = {
                product:   title,
                url:       item.url,
                price:     (item.line_price / 100).toFixed(2),
                variant:   item.variant_title || '',
                cartTotal: (cart.total_price / 100).toFixed(2),
                trigger:   'welcome-back-cart'
              };

              shown = ToptureCrisp.showText(
                "Welcome back! You still have the **" + title + "** in your cart. "
                + "Any questions about shipping, financing, or installation? "
                + "We're here to help you get it across the finish line.",
                cartCtx
              );
            } else {
              shown = _showByVisitCount(prev.count);
            }

            if (shown) ToptureCrisp.logWelcomeBack();
          })
          .catch(function(){
            if (ToptureCrisp.hasTriggered()) return;
            var shown = _showByVisitCount(prev.count);
            if (shown) ToptureCrisp.logWelcomeBack();
          });
      }, 2500);

      function _showByVisitCount(count){
        var ctx = { trigger: 'welcome-back-visit-' + count };

        if (count === 2) {
          return ToptureCrisp.showText(
            "Welcome back! Still exploring? If you'd like help comparing models "
            + "or have questions about installation, we're here.",
            ctx
          );
        } else if (count <= 4) {
          return ToptureCrisp.showText(
            "Good to see you again. You've been doing your research \u2014 smart move "
            + "on a purchase like this. Want us to help you narrow it down?",
            ctx
          );
        } else {
          return ToptureCrisp.showPicker(
            "wb-deep-visitor",
            "You've been researching for a while \u2014 we get it, this is a big decision. "
            + "Anything we can help with?",
            [
              { value: "financing", icon: "💰", label: "Monthly financing options", selected: false },
              { value: "compare",   icon: "🔍", label: "Help me compare models",    selected: false },
              { value: "consult",   icon: "📞", label: "Book a quick consultation",  selected: false }
            ],
            ctx
          );
        }
      }
    })();
  }

  /* ═══════════════════════════════════════════
   * Exit-intent trigger (product + collection pages)
   * Desktop: mouseout detection.
   * Mobile: inactivity timer (45s idle after 20s engagement).
   * ═══════════════════════════════════════════ */
  if (isProduct || isCollection) {
    (function(){
      if (ToptureCrisp.hasTriggered()) return;
      if (sessionStorage.getItem('topture_exit_shown')) return;

      var pageType     = isProduct ? 'product' : 'collection';
      var productName  = null;
      var productUrl   = null;
      var productPrice = null;

      /* Product data hydrated by crisp-shared-utils.liquid into window._toptureProduct */
      if (isProduct && window._toptureProduct) {
        productName  = window._toptureProduct.title;
        productUrl   = window._toptureProduct.url;
        productPrice = window._toptureProduct.price;
      }

      var MIN_ENGAGE   = 20000;
      var IDLE_TIMEOUT  = 45000;
      var engaged       = false;
      var fired         = false;
      var idleTimer     = null;
      var lastScrollAt  = 0;

      setTimeout(function(){ engaged = true; }, MIN_ENGAGE);

      function fire(){
        if (fired) return;
        if (!engaged) return;
        if (ToptureCrisp.hasTriggered()) return;

        fired = true;

        var ctx = {
          product: productName,
          url:     productUrl,
          price:   productPrice,
          trigger: 'exit-intent-' + pageType
        };

        var msg;
        if (pageType === 'product' && productName) {
          msg = "Have questions about the **" + productName + "**? "
              + "Our team has helped hundreds of homeowners choose the right setup. "
              + "We're here if you need us.";
        } else {
          msg = "Not sure which model fits your space? "
              + "Tell us about your setup and we'll help you narrow it down.";
        }

        var shown = ToptureCrisp.showText(msg, ctx);
        if (shown) sessionStorage.setItem('topture_exit_shown', '1');
      }

      function isMobile(){
        return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
            || window.innerWidth < 768;
      }

      if (!isMobile()) {
        document.addEventListener('mouseout', function(e){
          if (fired || !engaged) return;
          if (e.clientY > 0 || e.relatedTarget) return;
          fire();
        });
      }

      if (isMobile()) {
        var resetIdleTimer = function(){
          lastScrollAt = Date.now();
          clearTimeout(idleTimer);
          if (!engaged || fired) return;

          idleTimer = setTimeout(function(){
            if (Date.now() - lastScrollAt >= IDLE_TIMEOUT - 500) {
              fire();
            }
          }, IDLE_TIMEOUT);
        };

        window.addEventListener('scroll', resetIdleTimer, { passive: true });
        window.addEventListener('touchstart', resetIdleTimer, { passive: true });

        setTimeout(function(){
          if (!fired) resetIdleTimer();
        }, MIN_ENGAGE);
      }
    })();
  }

})();
